export enum EnvironmentType
{
    Local = "Local",
    Staging = "Staging",
    Beta = "Beta",
    Production = "Production",
    Test = "Test",
    Development = "Development",
    WarpSync = "WarpSync",
    External = "External"
}
